<ng-template #defaultMenuItems let-categories>
	<mat-nav-list *ngFor="let categoryMenuItem of categories" [id]="('menu-'+ categoryMenuItem.name).kebabize()">
		<div mat-subheader class="mat-subheader-sticky app-acrylic">
			<mat-icon class="mat-accent" *ngIf="categoryMenuItem.icon">{{categoryMenuItem.icon}}</mat-icon>
			<mat-icon [svgIcon]="categoryMenuItem.svgIcon" *ngIf="categoryMenuItem.svgIcon"></mat-icon>
			<span class="{{categoryMenuItem.color ?? 'mat-accent-gradient'}}">{{categoryMenuItem.name}}</span>
		</div>
		<ng-container *ngFor="let menuItem of categoryMenuItem.children">
			<div mat-list-item *ngIf="!menuItem.url && !menuItem.link" [id]="('menu-'+ categoryMenuItem.name +'-'+ menuItem.name).kebabize()" 
                style="font-size: 14px; padding: 8px 16px !important;">
				<div matLine *ngIf="menuItem.name" class="mat-list-item-title">{{menuItem.name}}</div>
				<div matLine *ngIf="menuItem.description" class="mat-list-item-description mat-grey">{{menuItem.description}}</div>
			</div>
			<a mat-list-item *ngIf="!isExternalLink(menuItem.link)" [routerLink]="(menuItem.canActivate === undefined || menuItem.canActivate === true) ? menuItem.link : null" 
                [id]="('menu-'+ categoryMenuItem.name +'-'+ menuItem.name).kebabize()"
                [disabled]="menuItem.canActivate === false">
				<div matLine *ngIf="menuItem.name" class="mat-list-item-title">{{menuItem.name}}</div>
				<div matLine *ngIf="menuItem.description" class="mat-list-item-description mat-grey">{{menuItem.description}}</div>
			</a>
			<a mat-list-item *ngIf="isExternalLink(menuItem.link)" [attr.href]="(menuItem.canActivate === undefined || menuItem.canActivate === true) ? menuItem.link : null" 
                rel="noopener" 
                [id]="('menu-'+ categoryMenuItem.name +'-'+ menuItem.name).kebabize()"
                [disabled]="menuItem.canActivate === false">
				<div matLine *ngIf="menuItem.name" class="mat-list-item-title">{{menuItem.name}}</div>
				<div matLine *ngIf="menuItem.description" class="mat-list-item-description mat-grey">{{menuItem.description}}</div>
			</a>
		</ng-container>
		<div mat-list-item fxLayoutAlign="center" style="margin-top: 8px">
			<a mat-button *ngIf="categoryMenuItem.childrenMore" [routerLink]="categoryMenuItem.childrenMore.link">
				{{categoryMenuItem.childrenMore.label}}
				<mat-icon>navigate_next</mat-icon>
			</a>
		</div>
	</mat-nav-list>
</ng-template>

<ng-template #richMenuItems let-items let-id="id">
	<mat-nav-list *ngFor="let categoryMenuItem of items" disableRipple [id]="('menu-'+ categoryMenuItem.name).kebabize()">
		<div mat-subheader class="mat-subheader-sticky app-acrylic">
			<mat-icon class="mat-accent" *ngIf="categoryMenuItem.icon">{{categoryMenuItem.icon}}</mat-icon>
			<span class="mat-accent-gradient">{{categoryMenuItem.name}}</span>
		</div>
		<mat-list-item *ngFor="let item of categoryMenuItem.children"
			[ngClass]="{'mat-elevation-z0 mat-selected-list-item': currentItem === item}"
			[ngStyle]="{'cursor': currentItem === item ? 'unset' : 'pointer'}"
			[ngStyle.xs]="{'max-width': 'calc(100vw - 48px)'}"
			(click)="currentItem = item"
            [id]="('menu-'+ categoryMenuItem.name +'-'+ item.title).kebabize()">
		
			<mat-user-picture mat-list-avatar fxFlexAlign="start" *ngIf="item.hasOwnProperty('picture')" [src]="item.picture | apiUrl"
				[matBadge]="item?.connection?.icon" matBadgeIcon matBadgePosition="below" [matBadgeHidden]="!item.connection"
				[matBadgeColorize]="'mat-'+ item?.connection?.color"></mat-user-picture>

			<mat-icon mat-list-icon class="mat-grey" *ngIf="id === 'etablissements'">apartment</mat-icon>

			<div matLine *ngIf="item.title" class="mat-list-item-title">{{item.title}}</div>
			<div matLine *ngFor="let line of item.description" class="mat-list-item-description mat-grey">{{line}}</div>

			<div matLine [smoothHeight]="currentItem?.link">
				<ng-container *ngIf="currentItem === item">
					<div *ngIf="item.mail" class="mat-grey mat-selected-list-sub-item">{{item.mail}}</div>
					<div *ngIf="!item.coordonnees && item.email" class="mat-grey mat-selected-list-sub-item">{{item.email}}</div>
					<div *ngIf="item.mobile" class="mat-grey mat-selected-list-sub-item">{{item.mobile | phoneNumber}}</div>
					<div *ngIf="!item.coordonnees && item.telephone" class="mat-grey mat-selected-list-sub-item">{{item.telephone | phoneNumber}}</div>
					<div *ngIf="!item.coordonnees && item.fax" class="mat-grey mat-selected-list-sub-item">{{item.fax | phoneNumber}} (fax)</div>

                    <div *ngIf="item.coordonnees?.length">
                        <div *ngFor="let coord of item.coordonnees"class="mat-grey mat-selected-list-sub-item">
                            <div *ngIf="item.coordonnees?.length > 1" >{{coord.lb_service}}</div>
                            <div *ngIf="coord.email">{{coord.email}}</div>
                            <div *ngIf="coord.telephone">{{coord.telephone | phoneNumber}}</div>
                            <div *ngIf="coord.fax">{{coord.fax | phoneNumber}} (fax)</div><br/>
                        </div>
                    </div>

					<div fxLayout="row wrap" fxLayoutAlign="end center" style="margin-top: 8px">
						<button *ngIf="id === 'users' && me.can('god') && !me.isImpersonate && item.guid" mat-button 
                            (click)="onImpersonate.next(item)" class="mat-purple">
							<mat-icon>person_outline</mat-icon>
							Imiter
						</button>
						<div fxFlex="1 1 0"></div>
						<a *ngIf="item.link" mat-button [routerLink]="item.link">
							Afficher
							<mat-icon>navigate_next</mat-icon>
						</a>
					</div>
				</ng-container>
			</div>
		</mat-list-item>
		<div mat-list-item fxLayoutAlign="center" style="margin-top: 8px">
            <a mat-button *ngIf="categoryMenuItem.childrenMore" [routerLink]="categoryMenuItem.childrenMore.link">
                {{categoryMenuItem.childrenMore.label}}
                <mat-icon>navigate_next</mat-icon>
            </a>
		</div>
	</mat-nav-list>
</ng-template>

<ng-container *ngIf="currentMainItem">
    <div *ngIf="currentMainItem?.id === 'search' && currentMainItem.children?.length <= 1 && !searchState.isWaiting">
        <mat-nav-list>
            <div mat-subheader class="mat-subheader-sticky">
                <mat-icon>search</mat-icon>
                Recherche
            </div>
            <mat-list-item disableRipple class="mat-grey app-text">
                Aucun résultat pour cette recherche
            </mat-list-item>
        </mat-nav-list>
    </div>
    <ng-container [ngSwitch]="currentMainItem.id">
        <ng-container *ngSwitchCase="'search'">
            <ng-container *ngFor="let zoneItem of currentMainItem.children">
                <ng-container [ngSwitch]="zoneItem.id">
                    <ng-container *ngSwitchCase="'users'">
                        <ng-container *ngTemplateOutlet="richMenuItems; context: {$implicit: zoneItem.children, id: zoneItem.id}"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'etablissements'">
                        <ng-container *ngTemplateOutlet="richMenuItems; context: {$implicit: zoneItem.children, id: zoneItem.id}"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <ng-container *ngTemplateOutlet="defaultMenuItems; context: {$implicit: zoneItem.children}"></ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="defaultMenuItems; context: {$implicit: currentMainItem.children}"></ng-container>
        </ng-container>
    </ng-container>
</ng-container>